import React from 'react';
import { formatMoney } from '../../utils/todayStats';

const TILES = [
  { key: 'totalLeads', label: 'TOTAL LEADS' },
  { key: 'needsYou', label: 'NEEDS YOU' },
  { key: 'booked', label: 'BOOKED' },
  { key: 'openPipelineValue', label: 'OPEN PIPELINE', isMoney: true },
];

export default function StatStrip({ stats, isMobile }) {
  return (
    <div
      className="today-stat-strip"
      style={{
        gridTemplateColumns: isMobile ? 'repeat(2, minmax(0, 1fr))' : 'repeat(4, minmax(0, 1fr))',
      }}
    >
      {TILES.map((tile) => {
        const raw = stats[tile.key];
        const display = tile.isMoney ? (formatMoney(raw) || '0') : String(raw ?? 0);
        return (
          <div key={tile.key} className="today-stat-card">
            <div className="today-stat-label">{tile.label}</div>
            <div className="today-stat-value">{display}</div>
          </div>
        );
      })}
    </div>
  );
}
